import type { Testkit, UniDriver } from 'ricos-types/testkit';
import { dataHook } from 'wix-rich-content-common';

import { BOLD_BUTTON_DATA_HOOK } from './data-hooks';

export type BoldTestkit = Testkit<{
  content: object;
  toolbars: {
    createTextButtonToolbars: (getTextButtonToolbarBase: () => UniDriver<Element>) => {
      click: () => Promise<void>;
      getElement: () => Promise<UniDriver<Element>>;
    };
  };
}>;

export const createBoldTestkit: BoldTestkit = () => {
  return {
    content: {},
    toolbars: {
      createTextButtonToolbars: (getTextButtonToolbarBase: () => UniDriver<Element>) => ({
        click: async () => {
          const button = getTextButtonToolbarBase().$(dataHook(BOLD_BUTTON_DATA_HOOK));
          await button.click();
        },
        getElement: () => getTextButtonToolbarBase().get(dataHook(BOLD_BUTTON_DATA_HOOK)),
      }),
    },
  };
};
